module.exports = __webpack_public_path__ + "img/C1.d4edf580.png";